import { createBrowserRouter } from "react-router-dom";
import Layout from "../layout";
import { AuthRoutes, AppRoutes } from "./AppRoutes";
import PrivateRoute from "./PrivateRoute";
import RouteRedirect from "./RouteRedirect";
import { routes } from "./routes";
import Auth from "../auth";
import Error404 from "../components/pages/others/errorPage/Error404";
import CheckEmail from "../auth/ForgotPassword";

const basename = process.env.REACT_APP_BASE_URL || "/";

const RouterProvider = createBrowserRouter(
  [
    {
      element: <PrivateRoute />,
      children: [
        { path: routes.Home, element: <Auth />, index: true },
        { path: routes.Login, element: <Auth /> },
      ],
    },
    {
      element: <RouteRedirect />,
      children: [
        {
          element: <Layout />,
          children: AppRoutes,
        },
        {
          children: AuthRoutes,
        },
      ],
    },
    {path:routes.ResetPassword,element:<CheckEmail/>},

    { path: "*", element: <Error404 /> },
  ],
  {
    basename,
  }
);

export default RouterProvider;
